export const NexusMark = ({ className = "w-5 h-5", title = "Growthifye Nexus" }) => (
  <svg viewBox="0 0 32 32" className={className} role="img" aria-label={title} fill="none" xmlns="http://www.w3.org/2000/svg">
    {title && <title>{title}</title>}
    <path d="M16 3 27.3 9.5v13L16 29 4.7 22.5v-13L16 3Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M10.5 21.5V10.5l11 11V10.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="10.5" cy="10.5" r="1.9" fill="rgb(var(--gf-primary))" />
    <circle cx="21.5" cy="21.5" r="1.9" fill="rgb(var(--gf-primary))" />
  </svg>
);
